import { defineMessages } from "react-intl";

export const UNEXPECTED_SKU_UNITS_LABELS = defineMessages({
  greaterThanZero: { id: "warehouse.greaterThanZero", defaultMessage: "Quantity must be greater than 0" },
});
